import { i18n } from '../../i18n';




export const filterColumnsHash = {
  desc_cont: {
    label: i18n.t('post.desc'),
    renderCell: {
      component: 'input'
    }
  },
  subtitle_cont: {
    label: i18n.t('post.subtitle'),
    renderCell: {
      component: 'input'
    }
  },
  title_cont: {
    label: i18n.t('post.title'),
    renderCell: {
      component: 'input'
    }
  },
}

export const columnsHash = {
  id: {
    label: i18n.t('post.id'),
    width: 80,
  },
  desc: {
    label: i18n.t('post.desc'),
  },
  subtitle: {
    label: i18n.t('post.subtitle'),
  },
  title: {
    label: i18n.t('post.title'),
  },
  position: {
    label: i18n.t('post.position'),
  },
  created_at: {
    label: i18n.t('post.createdAt'),
    minWidth: 120,
    renderCell: 'time',
  },
  updated_at: {
    label: i18n.t('post.updatedAt'),
    minWidth: 120,
    renderCell: 'time',
  },
  avatar: {
    label: i18n.t('post.avatar'),
    width: 120,
    renderCell: 'storageAttachment',
  },
  image: {
    label: i18n.t('post.image'),
    width: 120,
    renderCell: 'storageAttachment',
  },
  share_image: {
    label: i18n.t('post.shareImage'),
    width: 120,
    renderCell: 'storageAttachment',
  },
}

export const formColumnsHash = {
  desc: {
    label: i18n.t('post.desc'),
    renderCell: {
      required: true,
      component: 'input',
    },
  },
  subtitle: {
    label: i18n.t('post.subtitle'),
    renderCell: {
      required: true,
      component: 'input',
    },
  },
  title: {
    label: i18n.t('post.title'),
    renderCell: {
      required: true,
      component: 'input',
    },
  },
  position: {
    label: i18n.t('post.position'),
    renderCell: {
      component: 'input',
      props: {
        type: 'number'
      },
    },
  },
  avatar: {
    label: i18n.t('post.avatar'),
    width: 120,
    renderCell: {
      required: true,
      component: 'upload',
    }
  },
  image: {
    label: i18n.t('post.image'),
    width: 120,
    renderCell: {
      required: true,
      component: 'upload',
    }
  },
  share_image: {
    label: i18n.t('post.shareImage'),
    width: 120,
    renderCell: {
      required: true,
      component: 'upload',
    }
  },
}
